const CircleArrowMoveUpLeftIcon = /*#__PURE__*/ [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.3691 11.474C9.86083 10.8438 8.82805 10.0631 9.01189 9.69249M9.01189 9.69249C8.90948 9.31454 9.90942 8.56745 10.3714 7.99756M9.01189 9.69249C11.0947 9.64717 12.369 9.89913 13.5991 11.124C14.8802 12.3997 15.091 13.7936 14.9873 16.0022", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { CircleArrowMoveUpLeftIcon as default };
//# sourceMappingURL=CircleArrowMoveUpLeftIcon.js.map
